import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ExamsService } from '../exams.service';
import { LoginService } from '../login.service';
import { PatientsService } from '../patients.service';

export interface PregnancyReportTable {
  examId: number;
  creationDate: string;
  examType: string;
  changedExamTitle: string;
}

@Component({
  selector: 'app-exam-print-history',
  templateUrl: './exam-print-history.component.html',
  styleUrls: ['./exam-print-history.component.scss'],
  standalone: false,
})
export class ExamPrintHistoryComponent implements OnInit {
  @Output() closed = new EventEmitter<void>();

  displayedColumns: string[] = ['print', 'name', 'date'];
  pregnancyReports: PregnancyReportTable[] = [];
  loadingPrint = false;
  hasError = false;

  constructor(
    private http: HttpClient,
    private ls: LoginService,
    private patServ: PatientsService,
    public es: ExamsService
  ) {}

  ngOnInit(): void {
    this.getPregnancyReports();
  }

  getPregnancyReports() {
    if (!this.es.examID) {
      return;
    }

    this.loadingPrint = true;
    this.hasError = false;

    this.http.get(`api/print-history/pregnancy/${this.es.examID.toString()}`).subscribe(
      (data: PregnancyReportTable[]) => {
        this.pregnancyReports = data;
        this.loadingPrint = false;
      },
      (err) => {
        console.warn(err);
        this.pregnancyReports = [];
        this.hasError = true;
        this.loadingPrint = false;
      }
    );
  }

  examName(row: PregnancyReportTable): string {
    return row.changedExamTitle ? `${row.examType} (${row.changedExamTitle})` : row.examType;
  }

  openReport(selectRow: PregnancyReportTable) {
    this.loadingPrint = true;
    this.hasError = false;

    const lang = this.ls.printLang ? this.ls.printLang : 'he-IL';
    const pid = this.patServ.getPat().PID;

    this.http
      .get(`/api/printpdf/${selectRow.examId}/${pid}/${lang}/y/n/simple/2/last`, {
        responseType: 'blob',
      })
      .subscribe(
        (data) => {
          const file = new Blob([data], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
          this.loadingPrint = false;
        },
        (err) => {
          console.warn(err);
          this.hasError = true;
          this.loadingPrint = false;
        }
      );
  }

  close() {
    this.closed.emit();
  }
}
